<template>
  <base-header
    :settings="settings"
    :is-addition-disabled="isAdditionDisabled"
    :is-deletion-disabled="isDeletionDisabled"
    :disabled="disabled"
    v-on="$listeners"
  >
    <span>Disparo realizado no dia</span>
    <span class="ml-1 text-picker d-flex" @click.stop="openDatePicker"
      >{{ settings.send_date }} <v-icon class="text-picker" small>mdi-chevron-down</v-icon></span
    >
    <v-dialog v-model="datePickerMenu" width="290">
      <v-card>
        <v-date-picker v-model="selectedDate" :disabled="disabled" :min="minDate" :max="maxDate" locale="pt-BR" outlined dense @input="setDate"></v-date-picker>
      </v-card>
    </v-dialog>
  </base-header>
</template>

<script>
import { DateTime } from 'luxon'
import BaseHeader from './BaseHeader.vue'
import { mariaCampaign } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-campaign'

export default {
  name: 'StaticDateHeaderDispatchPanel',
  components: { BaseHeader },
  mixins: [mariaCampaign],
  props: {
    settings: {
      type: Object,
      required: true,
    },
    isAdditionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isDeletionDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      datePickerMenu: false,
      selectedDate: '',
    }
  },
  computed: {
    minDate() {
      if (this.campaignHasOffers) {
        const startDate = this.findEarliestStartDate().minus({ days: 30 })
        return startDate < DateTime.now() ? DateTime.now().toFormat('yyyy-MM-dd') : startDate.toFormat('yyyy-MM-dd')
      }
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    maxDate() {
      if (this.campaignHasOffers) {
        return this.findLatestEndDate().toFormat('yyyy-MM-dd')
      }
      return ''
    },
  },
  mounted() {
    if (!this.settings.send_date) {
      this.$emit('update-header', { updateDispatchModel: 'updateStaticDate', value: DateTime.now().toFormat('dd/MM/yyyy') })
    }
    if (this.settings.send_date) {
      this.selectedDate = DateTime.fromFormat(this.settings.send_date, 'dd/MM/yyyy').toFormat('yyyy-MM-dd')
    }
  },
  methods: {
    openDatePicker() {
      this.datePickerMenu = true
    },
    findEarliestStartDate() {
      let startDate = DateTime.min(...this.campaign.offer_schedules.map((offer) => DateTime.fromISO(offer.start_date))) || DateTime.now()
      if (this.campaignHasOffers) {
        return startDate < DateTime.now() ? DateTime.now() : startDate
      }
      return startDate
    },
    findLatestEndDate() {
      return DateTime.max(...this.campaign.offer_schedules.map((offer) => DateTime.fromISO(offer.end_date)))
    },
    setDate() {
      const [ano, mes, dia] = this.selectedDate.split('-')
      this.$emit('update-header', { updateDispatchModel: 'updateStaticDate', value: `${dia}/${mes}/${ano}` })
      this.datePickerMenu = false
    },
  },
}
</script>
